import Reveal from "@/components/base/Reveal";
import { evidenceCards } from "@/mocks/home";

export default function EvidenceSection() {
  return (
    <section id="evidence" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.24em] text-primary-600">
                EVIDENCE ARCHIVE
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                证据材料入口
              </h2>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-secondary-600">
              聊天记录、录音证据、内部截图三类核心材料，按类型打包，入口更醒目，点开即可逐段对照。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {evidenceCards.map((card, index) => (
            <Reveal key={card.title} delay={80 * index}>
              <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 md:p-6">
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-700">
                    <i className={card.icon} />
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-700">
                    {card.updated}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {card.title}
                </h3>
                <span className="mt-1 text-xs font-medium text-accent-700">
                  {card.meta}
                </span>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-secondary-600">
                  {card.desc}
                </p>
                <a
                  href="#top"
                  className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-download-2-line text-base" />
                  {card.action}
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-6 flex flex-col gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4 sm:flex-row sm:items-center sm:justify-between md:p-5">
            <p className="flex items-center gap-2 text-sm text-accent-900">
              <i className="ri-information-line text-base" />
              全部材料均标注来源与核对时间，替换版本会保留历史记录可追溯。
            </p>
            <a
              href="#submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-300 px-4 py-2 text-sm font-medium text-accent-900 transition-colors hover:bg-accent-100"
            >
              <i className="ri-upload-2-line text-base" />
              补充新线索
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}